import React, { Component } from 'react';
// import {Link, browserHistory } from 'react-router';
// import $ from 'jquery';
import AboutHeader from './AboutHeader.js';
import WebFooter from './WebFooter.js';

export default class Web_downloads extends Component{
	componentDidMount()
	{
		if(screen.width < 800 )
		{
			window.location.href="/downloads";
		}
	}
	render(){
		document.title ="AquaDeals Downloads";
		return(
			<div className="web_deals web_downloads_page">
			 	<AboutHeader />
          		<div className="clr">&nbsp;</div>
          		<div className="clr">&nbsp;</div>
				<div>
					<div className="featr_blk">
					<div className="container">
					<div className="col-md-3"><img className="mob_splsh_img" src="https://aquadeals.in/admin/assets/images/splash_mob.png" alt="" /></div>
					<div className="col-md-9">
					<h3>Features</h3>
					<p>For fast and safe orders of Seed, Feed, Health Care, Machinery & Farm Equipment experience the AquaDeals app on your Android phone and order on the GO! We are sure you will find the best deals every time. Invite your Contacts and get AquaCash. Refer your friends to download the AquaDeals app, sign up using your referral code and earn Rs.2000 AquaCash. Your friend gets Rs.2000 AquaCash. And there’s more.</p>
					<div className="row">
					
					<div className="col-md-4 col-sm-4 featrs">
					<img src="https://aquadeals.in/admin/assets/images/deals.png" alt="" />
					<h4>Deals</h4>
					<p>Search several deals on Seed, Feed, Machinery etc right from your mobile deals on Seed.</p>
					</div>
					
					<div className="col-md-4 col-sm-4 featrs">
					<img src="https://aquadeals.in/admin/assets/images/sp_offers.png" alt=""/>
					<h4>Special Offers</h4>
					<p>Celebrate the best of offers that you can ever get for your aqua business. Profit, Share, WalletUp!</p>
					</div>
					
					<div className="col-md-4 col-sm-4 featrs">
					<img src="https://aquadeals.in/admin/assets/images/refer_earn.png" alt="" />
					<h4>Refer &amp; Earn</h4>
					<p>Fill your wallet with the magical AquaCash by just sharing with your friends across.</p>
					</div>
					
					</div>
					</div>
					</div>

					</div>

					<div className="container qr_codes">
					<div className="col-md-4 col-sm-4 qr_blk">
					<img className="qr_img" src="https://aquadeals.in/admin/assets/images/google_play_qr.png" alt="" />
					<h5><a href="https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en" target="_blank">Google Play</a></h5>
					<img className="qr_icon" src="https://aquadeals.in/admin/assets/images/google_play.png" alt="" />
					</div>
					<div className="col-md-4 col-sm-4 qr_blk">
					<img className="qr_img" src="https://aquadeals.in/admin/assets/images/mobile_web_qr.png" alt="" />
					<h5><a href="http://aquadeals.in" target="_blank">aquadeals.in</a></h5>
					<img className="qr_icon qr_mob_icon" src="https://aquadeals.in/admin/assets/images/mobile_web.png" alt="" />
					</div>
					<div className="col-md-4 col-sm-4 qr_blk">
					<img className="qr_img" src="https://aquadeals.in/admin/assets/images/desktop_web_qr.png" alt="" />
					<h5><a href="http://aquadeals.in/web" target="_blank">aquadeals.in/web</a></h5>
					<img className="qr_icon" src="https://aquadeals.in/admin/assets/images/desktop_web.png" alt="" />
					</div>
					</div>

					{/*<div className="sam_scner">
					<div className="container">

					<div className="media">
					<div className="media-left">
					<a href="https://play.google.com/store/apps/details?id=com.nyros.scanner&hl=en" target="_blank" className="sam_scan_blk"><img className="media-object" src="https://aquadeals.in/admin/assets/images/qr_app_icon.png" alt="" /></a>
					</div>
					<div className="media-body">
						<h4 className="media-heading">Simple QR Bar Code Scanner</h4>
						<p>Simple scanner allows you scan bar codes, QR codets easily. This app is without any Ad which allows you to browse every feature seamlessly. You can create QR codes and share it instantly with your friends. </p>
					</div>
					</div>

					</div>
					</div>*/}

				</div>
				<WebFooter />
			</div>
		);
	}
}




/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Common/Web_downloads.js
 **/